export const enum SidebarMutationTypes {
    M_SET_SIDEBAR_SHOW = 'M_SET_SIDEBAR_SHOW',
}
